import { getRgObjectsOfType as r, RG_TYPE as f } from "@project-rouge/rg-core";
import { getPolygonArea as s } from "../../../geometry-utils/core/index14.js";
const d = (l, t) => {
  let o = 0;
  const n = r(l, f.Building);
  for (const i of n) {
    const g = i.data.levels.filter((e) => e.levelIndex === t);
    for (const e of g)
      !e.giaPolygon || (o += s(e.giaPolygon));
  }
  return o;
};
export {
  d as getLevelGIA
};
//# sourceMappingURL=index20.js.map
